var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPbsInstagram = function SvgPbsInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: "pbs-instagram_svg__pbs-instagram",
    viewBox: "0 0 17 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.718 13.3a3.923 3.923 0 0 1-3.918 3.918H4.353A3.923 3.923 0 0 1 .434 13.3V4.852A3.923 3.923 0 0 1 4.353.934H12.8a3.923 3.923 0 0 1 3.918 3.918zM8.576 4.085a4.996 4.996 0 0 0-4.99 4.991 4.996 4.996 0 0 0 4.99 4.99 4.996 4.996 0 0 0 4.99-4.99 4.996 4.996 0 0 0-4.99-4.99m5.139-1.474a1.286 1.286 0 1 0 0 2.573 1.286 1.286 0 0 0 0-2.573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.576 12.5a3.427 3.427 0 0 1-3.423-3.424 3.427 3.427 0 0 1 3.423-3.424A3.43 3.43 0 0 1 12 9.076 3.43 3.43 0 0 1 8.576 12.5"
  }))));
};
export default SvgPbsInstagram;